export default "__VITE_ASSET__BYg$iACk__"